type Props = {
  percentage: number;
  color?: string;
  isFirst?: boolean;
  offset?: number;
  strokeWidth?: number;
};

export function DonutSegment({
  percentage,
  offset = 0,
  color,
  isFirst = false,
  strokeWidth = 2.6,
}: Props) {
  const rotate = isFirst
    ? `rotate(0, 21, 21)`
    : `rotate(${offset * 3.6}, 21, 21)`;

  const gapSize = percentage < 0.3 ? percentage : 0.3;
  return (
    <circle
      className={"donut-segment"}
      data-per={percentage}
      cx={"21"}
      cy={"21"}
      r={"15.91549430918954"}
      fill={"transparent"}
      stroke={color}
      strokeWidth={strokeWidth}
      strokeDasharray={`${percentage - gapSize} ${100 - percentage + gapSize}`}
      transform={rotate}
    />
  );
}
